module.exports = __webpack_public_path__ + "img/icon-logo.39fd4488.png";